
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
const common_base = namespace("common_base");
@Component({
  inheritAttrs: false
})
export default class AreaSelect extends Vue {
  @Prop({ default: false })
  anyLevel: boolean;
  @common_base.Action getAreaList;
  props: any = {
    lazy: true,
    checkStrictly: false,
    label: "areaName",
    value: "areaName",
    lazyLoad: async (node, resolve) => {
      let { level, data: nodeData } = node;
      if (level === 0) {
        const data = await this.getAreaList();
        resolve(this.$safeValue(data, "data.list", []));
      } else {
        const data = await this.getAreaList({
          parentAreaCode: nodeData.areaCode
        });
        let list = this.$safeValue(data, "data.list", []);
        if (level === 2) {
          list = this.$safeValue(data, "data.list", []).map(item => {
            item.leaf = true;
            return item;
          });
        }
        resolve(list);
      }
    }
  };
  created() {
    this.props.checkStrictly = this.anyLevel;
  }
  getLabels() {
    let str = (this.$refs["com-area-select"] as any).querySelector(
      ".com-area-select .el-cascader .el-input__inner"
    ).value;
    return str.split(" / ");
  }
}
